import { Tab } from "@components/filtered/FilterBySelectTab/TabsTypes/TabTypes"
import { TabPromotionTypes } from "./types/TabPromotionTypes"
import { TabSettingsTypes } from "./types/TabSettingsTypes"

import chatIcon from "./assets/svg/navigate/chatNav.svg"
import eventIcon from "./assets/svg/navigate/eventNav.svg"
import favoritesIcon from "./assets/svg/navigate/favoritesNav.svg"
import friendsIcon from "./assets/svg/navigate/friendsNav.svg"
import myEventsIcon from "./assets/svg/navigate/myEventsNav.svg"
import profileIcon from "./assets/svg/navigate/profileNav.svg"
import CashierIcon from "./assets/svg/promotion-icon/cashierIcon"
import HomeIcon from "./assets/svg/promotion-icon/homeIcon"
import QrCodeIcon from "./assets/svg/promotion-icon/qrCodeIcon"

import OrganizerIcon from "./assets/svg/menu-icons-pack/diamond-icon-menu.svg?react"
import SettingsIcon from "./assets/svg/menu-icons-pack/settings-icon-menu.svg?react"
import ThemeIcon from "./assets/svg/menu-icons-pack/theme-icon-menu.svg?react"
import ProfileIcon from "./assets/svg/menu-icons-pack/user-icon-menu.svg?react"
import EventIcon from "./assets/svg/menu-icons-pack/world-icon-menu.svg?react"

import AccountIcon from "./assets/svg/profile-settings-tabs/account-icon-menu.svg?react"
import InterestsIcon from "./assets/svg/profile-settings-tabs/interests-icon-menu.svg?react"
import NotificationIcon from "./assets/svg/profile-settings-tabs/notification-icon-menu.svg?react"
import SecurityIcon from "./assets/svg/profile-settings-tabs/security-icon-menu.svg?react"
import SignoutIcon from "./assets/svg/profile-settings-tabs/signout-icon-menu.svg?react"

import BrowserIcon from "./assets/svg/profile-settings-notification/notification-browser-icon-menu.svg?react"
import ChatIcon from "./assets/svg/profile-settings-notification/notification-chat-icon-menu.svg?react"
import LikeIcon from "./assets/svg/profile-settings-notification/notification-like-icon-menu.svg?react"
import SoundIcon from "./assets/svg/profile-settings-notification/notification-sound-icon-menu.svg?react"

import KeyIcon from "./assets/svg/profile-settings-security/key-icon.svg?react"
import MailIcon from "./assets/svg/profile-settings-security/mail-icon.svg?react"
import PhoneIcon from "./assets/svg/profile-settings-security/phone-icon.svg?react"

import AnimalsIcon from "./assets/svg/profile-settings-category/animals-profile-category.svg?react"
import CountrysideIcon from "./assets/svg/profile-settings-category/countryside-profile-category.svg?react"
import CultureIcon from "./assets/svg/profile-settings-category/culture-profile-category.svg?react"
import GamesIcon from "./assets/svg/profile-settings-category/games-profile-category.svg?react"
import KidsIcon from "./assets/svg/profile-settings-category/kids-profile-category.svg?react"
import LoveIcon from "./assets/svg/profile-settings-category/love-profile-category.svg?react"
import OtherIcon from "./assets/svg/profile-settings-category/other-profile-category.svg?react"
import PartiesIcon from "./assets/svg/profile-settings-category/parties-profile-category.svg?react"
import ReligionIcon from "./assets/svg/profile-settings-category/religion-profile-category.svg?react"
import ShoppingIcon from "./assets/svg/profile-settings-category/shopping-profile-category.svg?react"
import SportIcon from "./assets/svg/profile-settings-category/sport-profile-category.svg?react"
import StudiesIcon from "./assets/svg/profile-settings-category/studies-profile-category.svg?react"
import TourismIcon from "./assets/svg/profile-settings-category/tourism-profile-category.svg?react"
import TravelIcon from "./assets/svg/profile-settings-category/travel-profile-category.svg?react"
import WalksIcon from "./assets/svg/profile-settings-category/walks-profile-category.svg?react"


export const navigateItems = [
  { title: "Cобытия", link: "/", icon: eventIcon },
  { title: "Профиль", link: "/profile", icon: profileIcon },
  { title: "Друзья", link: "/friends", icon: friendsIcon },
  { title: "Чат", link: "/chat", icon: chatIcon },
  { title: "Мои события", link: "", icon: myEventsIcon },
  { title: "Избранное", link: "/favorites", icon: favoritesIcon },
]

export const CATEGORY_SHOULD_DISPLAYED = ["/", "/map"]

export const MAX_VALUE_OF_NOTIFICATION_ON_THE_BELL = 99

export const ratingComments: (string | number)[][] = [
  ["Ужасно", 1],
  ["Терпимо", 2],
  ["Средне", 3],
  ["Хорошо", 4],
  ["Супер", 5],
]

export const monthsByIndex = [
  "Января",
  "Февраля",
  "Марта",
  "Апреля",
  "Мая",
  "Июня",
  "Июля",
  "Августа",
  "Сентября",
  "Октября",
  "Ноября",
  "Декабря",
]

export const CalendarCardIcon = {
  ru: [
    "Янв",
    "Фев",
    "Мар",
    "Апр",
    "Май",
    "Июн",
    "Июл",
    "Авг",
    "Сен",
    "Окт",
    "Ноя",
    "Дек",
  ],
  en: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
}

export const monthByLanguage = {
  ru: [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
  ],
  eng: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
}

export const month = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
]

export const menuIconsPack = [
  {
    icon: EventIcon,
    alt: {
      ru: "Иконка события",
      en: "Events icon",
    },
    path: "/",
    text: "События",
  },
  {
    icon: ProfileIcon,
    alt: {
      ru: "Иконка профиля",
      en: "Profile icon",
    },
    path: "/profile",
    text: "Профиль",
  },
  //{
  //  icon: ChatIcon,
  //  alt: {
  //    ru: "Иконка чата",
  //    en: "Chat icon",
  //  },
  //  path: "/chat",
  //  text: "Чат",
  //},
    {
    icon: LikeIcon,
    alt: {
      ru: "Иконка избранного",
      en: "Favorites icon",
    },
    path: "/favorites",
    text: "Избранное",
  },
  {
    icon: ThemeIcon,
    alt: {
      ru: "Иконка темы",
      en: "Theme icon",
    },
    path: "#",
    text: "Тема",
  },
]

export const profileIconsPack = [
  {
    icon: ProfileIcon,
    alt: {
      ru: "Иконка профиля",
      en: "Profile icon",
    },
    path: "/profile/myevents",
    text: "Профиль",
  },
  {
    icon: SettingsIcon,
    alt: {
      ru: "Иконка настроек",
      en: "Settings icon",
    },
    path: "/profile/settings",
    text: "Настройки",
  },
    {
    icon: ThemeIcon,
    alt: {
      ru: "Иконка темы",
      en: "Theme icon",
    },
    path: "#",
    text: "Тема",
  },
  {
    icon: OrganizerIcon,
    alt: {
      ru: "Иконка кабинета организатора",
      en: "Organizer's Dashboard icon",
    },
    path: "/profile/promotion",
    text: "Кабинет организатора",
  },
  {
    icon: SignoutIcon,
    alt: {
      ru: "Иконка выхода",
      en: "Exit icon",
    },
    path: "/",
    text: "Выход",
  },
]

export const dayTab: Tab = {
  paramKey: "day",
  title: "Время проведения",
  tabsName: ["Утро", "День", "Вечер", "Ночь"],
  tabsValue: {
    Утро: "MORNING",
    День: "AFTERNOON",
    Вечер: "EVENING",
    Ночь: "NIGHT",
  },
}

export const costTab: Tab = {
  paramKey: "isFree",
  title: "Стоимость",
  tabsName: ["Все", "Платные", "Бесплатные"],
  tabsValue: {
    Все: undefined,
    Платные: true,
    Бесплатные: false,
  },
}

export const AlcoholTab: Tab = {
  paramKey: "isPresenceOfAlcohol",
  title: "Алкоголь",
  tabsName: ["Нет", "Да", "Все"],
  tabsValue: {
    Нет: false,
    Да: true,
    Все: undefined,
  },
}

export const RestrictionTab: Tab = {
  paramKey: "isEighteenYearLimit",
  title: "Ограничения",
  tabsName: ["Есть", "18+", "Все"],
  tabsValue: {
    Есть: true,
    "18+": false,
    Все: undefined,
  },
}

export const selectValues = ["DATE", "DISTANCE", "ALCOHOL"]

export const sideMenuPromotionTabs: TabPromotionTypes[] = [
  {
    title: "Мероприятия",
    Icon: HomeIcon,
    link: "/profile/promotion/events",
  },
  {
    title: "Промоутеры",
    Icon: QrCodeIcon,
    link: "/profile/promotion/promotes",
  },
  {
    title: "Кассиры",
    Icon: CashierIcon,
    link: "/profile/promotion/cashier",
  },
]

export const sideMenuSettingsTabs: TabSettingsTypes[] = [
  {
    id: "profile",
    label: "Аккаунт и внешний вид",
    icon: AccountIcon,
  },
  {
    id: "security",
    label: "Безопасность",
    icon: SecurityIcon,
  },
  {
    id: "interests",
    label: "Интересы",
    icon: InterestsIcon,
  },
  {
    id: "notifications",
    label: "Настройка уведомлений",
    icon: NotificationIcon,
  },
]

export const notificationsSettings = [
  {
    icon: SoundIcon,
    alt: {
      ru: "Иконка для уведомлений со звуком",
      en: "Sound notification icon",
    },
    text: "Уведомления со звуком",
  },
  {
    icon: ChatIcon,
    alt: {
      ru: "Иконка для уведомлений о сообщениях в чат",
      en: "Chat notification icon",
    },
    text: "Сообщения в чат",
  },
  {
    icon: LikeIcon,
    alt: {
      ru: "Иконка для уведомлений мне нравится",
      en: "Favorite notification icon",
    },
    text: "Отметки мне нравится",
  },
  {
    icon: BrowserIcon,
    alt: {
      ru: "Иконка для браузерных уведомлений",
      en: "Browser notification icon",
    },
    text: "Браузерные уведомления",
  },
]

export const securitySettings = [
  {
    icon: PhoneIcon,
    alt: "phone",
    text: "Телефон",
  },
  {
    icon: MailIcon,
    alt: "email",
    text: "Почта",
  },
  {
    icon: KeyIcon,
    alt: "password",
    text: "Пароль",
  },
]

export const interests = [
  /* id должно совпадать с id в категориях
  src\common\category\useCategoryProvider.ts
  localCategory: CategoryInfo[]*/
  {
    id: 15,
    text: "Любовь",
    icon: LoveIcon,
    alt: {
      ru: "Иконка категории любовь",
      en: "Love category icon",
    },
  },
  {
    id: 4,
    text: "Вечеринки",
    icon: PartiesIcon,
    alt: {
      ru: "Иконка категории вечеринки",
      en: "Parties category icon",
    },
  },
  {
    id: 17,
    text: "Игры",
    icon: GamesIcon,
    alt: {
      ru: "Иконка категории игры",
      en: "Games category icon",
    },
  },
  {
    id: 18,
    text: "Шопинг",
    icon: ShoppingIcon,
    alt: {
      ru: "Иконка категории шопинг",
      en: "Shopping category icon",
    },
  },
  {
    id: 1,
    text: "Спорт",
    icon: SportIcon,
    alt: {
      ru: "Иконка категории спорт",
      en: "Sport category icon",
    },
  },
  {
    id: 2,
    text: "Поездки",
    icon: TravelIcon,
    alt: {
      ru: "Иконка категории поездки",
      en: "Travel category icon",
    },
  },
  {
    id: 5,
    text: "Обучение",
    icon: StudiesIcon,
    alt: {
      ru: "Иконка категории обучение",
      en: "Studies category icon",
    },
  },
  {
    id: 7,
    text: "Для детей",
    icon: KidsIcon,
    alt: {
      ru: "Иконка категории для детей",
      en: "Kids category icon",
    },
  },
  {
    id: 8,
    text: "Отдых за городом",
    icon: CountrysideIcon,
    alt: {
      ru: "Иконка категории отдых за городом",
      en: "Counryside category icon",
    },
  },
  {
    id: 9,
    text: "Религия",
    icon: ReligionIcon,
    alt: {
      ru: "Иконка категории религия",
      en: "Religion category icon",
    },
  },
  {
    id: 12,
    text: "Туризм",
    icon: TourismIcon,
    alt: {
      ru: "Иконка категории туризм",
      en: "Tourism category icon",
    },
  },
  {
    id: 13,
    text: "Прогулки",
    icon: WalksIcon,
    alt: {
      ru: "Иконка категории прогулки",
      en: "Walks category icon",
    },
  },
  {
    id: 16,
    text: "Культура",
    icon: CultureIcon,
    alt: {
      ru: "Иконка категории культура",
      en: "Culture category icon",
    },
  },
  {
    id: 14,
    text: "Для животных",
    icon: AnimalsIcon,
    alt: {
      ru: "Иконка категории для животных",
      en: "Animals category icon",
    },
  },
  {
    id: 19,
    text: "Другое",
    icon: OtherIcon,
    alt: {
      ru: "Иконка категории другое",
      en: "Other category icon",
    },
  },
]
